__turbopack_context__.v({
  "conditions__colSubtitle": "ConditionsItem-module-scss-module__IXpnGq__conditions__colSubtitle",
  "conditions__colTitle": "ConditionsItem-module-scss-module__IXpnGq__conditions__colTitle",
  "conditions__colWrapper": "ConditionsItem-module-scss-module__IXpnGq__conditions__colWrapper",
  "conditions__contentContainer": "ConditionsItem-module-scss-module__IXpnGq__conditions__contentContainer",
  "conditions__contentWrapper": "ConditionsItem-module-scss-module__IXpnGq__conditions__contentWrapper",
  "conditions__extraNodeWrapper": "ConditionsItem-module-scss-module__IXpnGq__conditions__extraNodeWrapper",
  "conditions__gridWrapper": "ConditionsItem-module-scss-module__IXpnGq__conditions__gridWrapper",
  "conditions__icon": "ConditionsItem-module-scss-module__IXpnGq__conditions__icon",
  "conditions__item": "ConditionsItem-module-scss-module__IXpnGq__conditions__item",
  "conditions__itemTitle": "ConditionsItem-module-scss-module__IXpnGq__conditions__itemTitle",
  "conditions__itemWrapper": "ConditionsItem-module-scss-module__IXpnGq__conditions__itemWrapper",
});
